export default {
  properties: null,
  current_property: null,
  amenities: null,
  searchResults: null,
  searchResultsCurrentPage: 1,
  searchResultsTotal: 1,
  loading: true,
  query: null,
};
